import { DatePipe } from '@angular/common';
import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BeanJustificativa } from 'src/bean/BeanJustificativa';
import { BeanMonitoria } from 'src/bean/BeanMonitoria';
import { BeanMotivo } from 'src/bean/BeanMotivo';
import { BeanOperacao } from 'src/bean/BeanOperacao';
import { BeanParameter } from 'src/bean/BeanParameter';
import { BeanParametroXMotivo } from 'src/bean/BeanParametroXMotivo';
import { BeanPerfil } from 'src/bean/BeanPerfil';
import { BeanQuestionXAnswers } from 'src/bean/BeanQuestionXAnswers';
import { BeanAnswer } from '../../../bean/BeanAnswer';
import { BeanCategory } from '../../../bean/BeanCategory';
import { BeanCategoryGroup } from '../../../bean/BeanCategoryGroup';
import { BeanFormulario } from '../../../bean/BeanFormulario';
import { BeanProfile } from '../../../bean/BeanProfile';
import { BeanQuestion } from '../../../bean/BeanQuestion';
import { BeanStatus } from '../../../bean/BeanStatus';
import { CadastroUsuarioService } from '../cadastro-usuario/cadastro-usuario.service';
import { ObservacaoMonitoriaDialog } from '../monitoria/monitoria.component';
import { PrevParametroMotivoDialog } from '../monitoria/parametro-motivo-dialog/parametro-motivo-dialog';
import { CadastroFichaMonitoriaService } from './cadastro-ficha-monitoria.service';
import { JustificationService } from './conteudo-global/justification.service';
import { ProfileService } from './conteudo-global/profile.service';
import { StatusService } from './conteudo-global/status.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';


@Component({
  selector: 'app-cadastro-ficha-monitoria',
  templateUrl: './cadastro-ficha-monitoria.component.html',
  styleUrls: ['./cadastro-ficha-monitoria.component.css'],
  providers: [DatePipe]
})
export class CadastroFichaMonitoriaComponent implements OnInit {

  public podeAlterarFormulario : boolean = false;
  public lstCmbOperacao: BeanOperacao[];
  public lstBeanFormulario: BeanFormulario [] = [];
  public lstBeanCategoryGroup: BeanCategoryGroup [] = [];

  public lstBeanCategory: BeanCategory [] = [];
  public lstBeanQuestion: BeanQuestion [] = [];
  public lstBeanAnswer: BeanAnswer [] = [];
  pergInExtraAux : string;
  public lstBeanParameter: BeanParameter [] = [];
  public lstBeanMotivo: BeanMotivo [] = [];
  public lstBeanCabecalhoMotivo: BeanParametroXMotivo [] = [];
  public lstBeanCabecalhoMotivoCadastro: BeanParametroXMotivo [] = [];

  public lstBeanCmbParametroMot: BeanMotivo [] = [];
  public lstBeanCmbMotivoMot: BeanMotivo [] = [];

  public lstBeanQuestionXAnswers: BeanQuestionXAnswers [] = [];

  public disabledTab:boolean = true;
  public sessionExpired = false;

  colunasProfile: string[] = ['perfDsPerfil', 'perfDhInativo'];
  colunasStatus: string[] = ['statDsStatus', 'statInConfiguracao', 'statDhInativo'];
  colunasJustificativa: string[] = ['justDsJustificativa','justDhInativo'];
  idUsuarioEdicao : number = 1 ;

  beanProfile: BeanProfile;
  beanStatus: BeanStatus;
  beanJustificativa: BeanJustificativa;

  dataSourceFicha = new MatTableDataSource<BeanFormulario>();
  dataSourceFormularioAux = new BeanFormulario(0,'','','','','','',0,null,null,null,'');
  dataSourceGrupoCategoria = new MatTableDataSource<BeanCategoryGroup>();
  dataSourceCategoria = new MatTableDataSource<BeanCategory>();
  dataSourcePergunta = new MatTableDataSource<BeanQuestion>();
  dataSourceResposta = new MatTableDataSource<BeanAnswer>();
  dataSourceParametro = new MatTableDataSource<BeanParameter>(this.lstBeanParameter);
  dataSourceMotivo = new MatTableDataSource<BeanMotivo>(this.lstBeanMotivo);
  dataSourceParametroXMotivo = new MatTableDataSource<BeanParametroXMotivo>(this.lstBeanCabecalhoMotivo);
  dataSourceQuestionXAnswers = new MatTableDataSource<BeanQuestionXAnswers>(this.lstBeanQuestionXAnswers);


  dataSourceProfile = new MatTableDataSource<BeanProfile>();
  status = new MatTableDataSource<BeanStatus>();
  justificativa = new MatTableDataSource<BeanJustificativa>();
  isBloquearPontuacao : boolean = false;
  indexMenu: number = 0;
  indexFormulario: number = 0;
  indexConteudoGlobal: number = 0;
  indexSubMenu: number = 0;
  indexCabecalho: number = 0;
  today;

  constructor(public dialog: MatDialog,
              private cadastroUsuarioService : CadastroUsuarioService,
              private cadastroFichaMonitoriaService: CadastroFichaMonitoriaService,
              private profileService : ProfileService,
              private statusService : StatusService,
              private justificationService : JustificationService,
              private toastr: ToastrService,
              private router: Router,
              private datePipe:DatePipe) { }

  @ViewChild('sortProfile') sortProfile = new MatSort();
  @ViewChild('sortStatus') sortStatus = new MatSort();
  @ViewChild('sortJustificativa') sortJustificativa = new MatSort();
  @ViewChild('sortCabecalho') sortCabecalho = new MatSort();
  @ViewChild('sortMotivo') sortMotivo = new MatSort();
  @ViewChild('parametroXMotivo') ParametroXMotivo = new MatSort();
  @ViewChild('sortGpCategoria') sortGpCategoria = new MatSort();
  @ViewChild('sortCategoria') sortCategoria = new MatSort();
  @ViewChild('sortPergunta') sortPergunta = new MatSort();
  @ViewChild('sortResposta') sortResposta = new MatSort();
  @ViewChild('sortPergXResp') sortPergXResp = new MatSort();

  ngOnInit(): void {
    this.preencheCmbOperacao();
    
  }

  ngAfterContentChecked(){

    this.resetSessionExpired();
  }

  public sair() {

    this.sessionExpired = false;
    localStorage.clear();
    this.router.navigate([''])

  }

  public setSessionExpired(errorResponse:any) : boolean {

    if(errorResponse.status == 401){

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired(){

    if(this.sessionExpired){

			this.sair();
			this.toastr.warning("Sua sessão expirou, faça o login novamente!");
		}
  }

  public aoMudarMenu(indexMenu:any){ //  | 0 - Ficha de Monitoria | 1 - Conteúdo Global | 2 - Estrutura |  \\

    if(indexMenu == 1){

      this.listarProfiles();
      this.listarStatus();
      this.listarJustificativa();
    }
  }
  //------------------ Métodos para carregar listas de acordo com a ABA selecionada ------------------ \\



  public aoMudarSubMenu(indexMenu:any, indexSubMenu:any, indexSubSubMenu:any){

    this.indexMenu = indexMenu;
    this.indexSubMenu = indexSubMenu;

    if(indexMenu == 0){

      if(indexSubMenu == 0){

        this.listarFormulario();

      }else if(indexSubMenu == 1){


        if(indexSubSubMenu == null || indexSubSubMenu == 0){

          this.listarParametroXMotivo();

          //settimeout de 1/2 segundo pois o meodo listarParametroXMotivo() acima precisa executar e preencher o bean ncessariopara adicionar se existe motivo para este cabeçalho
          setTimeout(() => {
            this.listarCabecalho();
          }, 200);



        }else if(indexSubSubMenu == 1){

          this.listarMotivo();

        }else if(indexSubSubMenu == 2){

          this.listarCmbParametro();
          this.listarCmbMotivo();
          this.listarParametroXMotivo();

        }




      }else if(indexSubMenu == 2){
        this.listarGrupo();

      }else if(indexSubMenu == 3){
        this.listarCategoria();

      }else if(indexSubMenu == 4){
        this.listarPerguntas();

      }else if(indexSubMenu == 5){
        this.listarRespostas();

      }else if(indexSubMenu == 6){
        this.listarPergXResp();

      }

    } else if(indexMenu == 1){
      if(indexSubMenu == 0){
        this.listarProfiles();

      }else if(indexSubMenu == 1){
        this.listarStatus();
      }else if(indexSubSubMenu == 2){
        this.listarJustificativa();
      }

    }
  }

  //Verifica se tem algum ID selecionado para EDIÇÃO
  verificaIdSelecionado(id: string){
    return id != "" ? false : true;
  }

  //--------------------------------- | PROFILE (PERFIL) - INICIO | -------------------------------- \\

  //DECLARAÇÃO DO FORM PARA CRIAR UM PERFIL
  public formProfile: FormGroup = new FormGroup({
    'perfIdCdPerfil': new FormControl(""),
    'perfDsPerfil': new FormControl("", Validators.required),
    'perfDhInativo': new FormControl("")
  })


  public addNovoFormulario(){
    this.podeAlterarFormulario = true;
    this.formulario.controls['idForm'].setValue(0);
    this.limparTudo();
    //this.toastr.success('Liberado criar formulário','Criar Novo')
  }


  public formulario: FormGroup = new FormGroup({

    'operacao': new FormControl("", Validators.required),
    'idForm': new FormControl("", Validators.required),
    'formAtivo': new FormControl("ativo", Validators.required),

    'idFichaMonitoria': new FormControl(""),
    'fichaMonitoria': new FormControl("", Validators.required),
    'versaoFicha': new FormControl("", Validators.required),
    'segmento': new FormControl("", Validators.required),
    'tipoFormulario': new FormControl("M", Validators.required),
    'inativoFicha': new FormControl(""),
    'formDsTipoPontuacao': new FormControl("SOMA"),


    'idFormParametro': new FormControl("", Validators.required),
    'idParametro': new FormControl(""),
    'paraInObrigatorio': new FormControl("", Validators.required),
    'paraDsParametro': new FormControl("", Validators.required),
    'paraDhInativo': new FormControl("", Validators.required),
    'paraNrOrdem': new FormControl("", Validators.required),


    'motivoformIdCdFormulario': new FormControl("", Validators.required),
    'motiIdCdMotivo': new FormControl(""),
    'motiDsMotivo': new FormControl("", Validators.required),
    'motiDhRegistro': new FormControl("", Validators.required),
    'motiDhInativo': new FormControl("", Validators.required),

    'mopaIdCdMotivoParametro' : new FormControl("", Validators.required),
    'paraIdCdParametroMotivo': new FormControl("", Validators.required),
    'motiIdCdMotivoMotivo': new FormControl("", Validators.required),

    'idFormGpCategoria': new FormControl("", Validators.required),
    'idGrupoCategoria' : new FormControl(""),
    'grcaDsGrupoCategoria': new FormControl("", Validators.required),
    'grcaInMapeamento': new FormControl(""),
    'grcaDhInativo': new FormControl(""),
    'grcaNrOrdem': new FormControl("", Validators.required),

    'idGrcaCategoria' : new FormControl("", Validators.required),
    'idCategoria' : new FormControl(""),
    'cateDhInativo': new FormControl(""),
    'cateDsCategoria': new FormControl("", Validators.required),
    'idGrupoCategoriaPergunta' : new FormControl("", Validators.required),
    'idCategoriaPergunta' : new FormControl("", Validators.required),
    'cateNrOrdem': new FormControl("", Validators.required),

    'idPergunta' : new FormControl(""),
    'descricaoPergunta': new FormControl("", Validators.required),
    'pergDsPergunta': new FormControl("", Validators.required),
    'pergDhInativo': new FormControl(""),
    'pergInExtra': new FormControl(""),
    'pergInRespostasemlista': new FormControl(""),
    'pergNrOrdem': new FormControl("", Validators.required),

    'idPergResposta' : new FormControl("", Validators.required),
    'idResposta' : new FormControl(""),
    'defaultResposta': new FormControl(""),
    'respDsResposta': new FormControl("", Validators.required),
    'respDhInativo': new FormControl(""),
    'respInNaoseaplica': new FormControl(""),
    'respNrOrdem': new FormControl("", Validators.required),

    'idGrupoCategoriaPergXResp': new FormControl("", Validators.required),
    'idCategoriaPergXRespa': new FormControl("", Validators.required),
    'idPere': new FormControl("", Validators.required),
    'pontuacaoPXR': new FormControl("", Validators.required),
    'pontuacaoPXRTrunfo': new FormControl("", Validators.required),
    'defaultPXR': new FormControl("", Validators.required),
    'zerarPXR': new FormControl("", Validators.required),
    'comentarioPXR': new FormControl("", Validators.required),
    'pereInZerar': new FormControl("", Validators.required),
    'pereDhInativo': new FormControl("")

  })

  //Adiciona valores do PERFIL na tela para editar as informações.
  setFormProfile(form: BeanProfile){
    this.toastr.success('Perfil '+form.perfDsPerfil+' em edição','MODO EDIÇÃO')
    this.formProfile.controls['perfIdCdPerfil'].setValue(form.perfIdCdPerfil);
    this.formProfile.controls['perfDsPerfil'].setValue(form.perfDsPerfil);
    this.formProfile.controls['perfDhInativo'].setValue(form.perfDhInativo == null ? false : true);
  }



  bloquearCampoPontuacao(event){

      if(event.checked == true){

        this.formulario.controls['pontuacaoPXR'].setValue("0");
        this.formulario.controls['pontuacaoPXR'].disable();

      }else{

        this.formulario.controls['pontuacaoPXR'].setValue("");
        this.formulario.controls['pontuacaoPXR'].enable();

      }

  }


  //Busca todos os PERFIS.
  public listarProfiles(){

    this.profileService.listarProfiles().then((retorno:any)=>{

      this.dataSourceProfile.data = retorno;
      this.dataSourceProfile.sort = this.sortProfile;
    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Profiles')

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }

  //Criar Perfil
  public criarProfile():void{

    if( this.formProfile.get("perfDsPerfil").value == ""){
      this.toastr.error('Preencha todos os campos obrigatórios antes de salvar', 'Obrigatoriedade')
      return
    }

    var dhInativo = null;

    if(this.formProfile.value.perfDhInativo == true){
      dhInativo = '1900-01-01T00:00:00' //preencher para o backend pega o getDate()
    }

    this.beanProfile = new BeanProfile(
      this.formProfile.value.perfIdCdPerfil,
      this.formProfile.value.perfDsPerfil,
      dhInativo,
      ''
    );

    if(this.formProfile.value.perfIdCdPerfil != '' && this.formProfile.value.perfIdCdPerfil > 0){

      //Editar Status
      this.profileService.updateProfile(this.beanProfile).then((retorno:any)=>{

        this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR')
        this.listarProfiles();
        this.clearProfile();

      },
        errorResponse => {
        console.log(errorResponse)
        this.toastr.error(' Erro ao Atualizar Perfil', 'ERRO AO ATUALIZAR')


      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });

    }else{

      //Criar novo Status
      this.profileService.addProfile(this.beanProfile).then((retorno:any)=>{

        this.toastr.success(' Inserido com sucesso', 'SUCESSO AO GRAVAR')
        this.listarProfiles();
        this.clearProfile();

      },
        errorResponse => {
          console.log(errorResponse)
          this.toastr.error(' Erro ao gravar Perfil', 'ERRO AO GRAVAR')

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });
    }
  }

  //Limpar Perfil
  clearProfile(){

    this.formProfile.controls['perfIdCdPerfil'].setValue("");
    this.formProfile.controls['perfDsPerfil'].setValue("");
    this.formProfile.controls['perfDhInativo'].setValue("");

  }

  //---------------------------------- | PROFILE (PERFIL) - FIM | ---------------------------------- \\


  //-------------------------------------- | STATUS - INICIO | ------------------------------------- \\

  //DECLARAÇÃO DO FORM PARA CRIAR UM STATUS
  public formStatus: FormGroup = new FormGroup({
    'statIdCdStatus': new FormControl(""),
    'statDsStatus': new FormControl("", Validators.required),
    'statInConfiguracao': new FormControl(""),
    'statDhInativo': new FormControl("")
  })

  //Adiciona valores do STATUS na tela para editar as informações.
  setFormStatus(form: BeanStatus){
    this.toastr.success('Status '+form.statDsStatus+' em edição','MODO EDIÇÃO')
    this.formStatus.controls['statIdCdStatus'].setValue(form.statIdCdStatus);
    this.formStatus.controls['statDsStatus'].setValue(form.statDsStatus);
    this.formStatus.controls['statInConfiguracao'].setValue(form.statInConfiguracao);
    this.formStatus.controls['statDhInativo'].setValue(form.statDhInativo == null ? false : true);
  }

  //Busca todos os STATUS.
  public listarStatus(){

    this.statusService.listarStatus().then((retorno:any)=>{

      this.status.data = retorno;
      this.status.sort = this.sortStatus;
    },
    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Status')

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }

  //Criar Status (Botão Salvar)
  public criarStatus():void{

    if( this.formStatus.get("statDsStatus").value == ""){
      this.toastr.error('Preencha todos os campos obrigatórios antes de salvar', 'Obrigatoriedade')
      return
    }

    var dhInativo = null;

    if(this.formStatus.value.statDhInativo == true){
      dhInativo = '1900-01-01T00:00:00' //preencher para o backend pega o getDate()
    }

    this.beanStatus = new BeanStatus();
    this.beanStatus = this.formStatus.value;

    this.beanStatus.statDhInativo = dhInativo;


    if(this.formStatus.value.statIdCdStatus != '' && this.formStatus.value.statIdCdStatus > 0){

      //Editar Status
      this.statusService.updateStatus(this.beanStatus).then((retorno:any)=>{

        this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR')
        this.listarStatus();
        this.clearStatus();

      },
        errorResponse => {
        console.log(errorResponse)
        this.toastr.error(' Erro ao Atualizar Status', 'ERRO AO ATUALIZAR')


      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });

    }else{

      //Criar novo Status
      this.statusService.addStatus(this.beanStatus).then((retorno:any)=>{

        this.toastr.success(' Inserido com sucesso', 'SUCESSO AO GRAVAR')
        this.listarStatus();
        this.clearStatus();

      },
        errorResponse => {
          console.log(errorResponse)
          this.toastr.error(' Erro ao gravar Status', 'ERRO AO GRAVAR')

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });
    }
  }

  //Limpar form (Botão Cancelar)
  clearStatus(){

    this.formStatus.controls['statIdCdStatus'].setValue("");
    this.formStatus.controls['statDsStatus'].setValue("");
    this.formStatus.controls['statInConfiguracao'].setValue("");
    this.formStatus.controls['statDhInativo'].setValue("");
  }

  //Valida se é STATUS de configuração
  public validaStatusConfiguracao(char: string):boolean{

    if(char == "N"){

      return false;
    }

    this.toastr.warning("Status ESSENCIAL para o funcionamento do SISTEMA!\nNão é possível alterá-lo.","AVISO STATUS");
    return true;
  }

  //--------------------------------------- | STATUS - FIM | --------------------------------------- \\

  //-------------------------------------- | JUSTIFICATIVA - INICIO | ------------------------------------- \\

  isReadonly = false;

  //DECLARAÇÃO DO FORM PARA CRIAR UMA JUSTIFICATIVA
  public formJustificativa: FormGroup = new FormGroup({
    'justIdCdJustificativa': new FormControl(""),
    'justDsJustificativa': new FormControl("", Validators.required),
    'justDhInativo': new FormControl("")
  })

  //Adiciona valores da JUSTIFICATIVA na tela para editar as informações.
  setFormJustificativa(form: BeanJustificativa){
    this.toastr.success('Justificativa '+form.justDsJustificativa+' em edição','MODO EDIÇÃO')
    this.formJustificativa.controls['justIdCdJustificativa'].setValue(form.justIdCdJustificativa);
    this.formJustificativa.controls['justDsJustificativa'].setValue(form.justDsJustificativa);
    this.formJustificativa.controls['justDhInativo'].setValue(form.justDhInativo == null ? false : true);

    this.isReadonly = true;
  }

  //Busca todos as JUSTIFICATIVAS.
  public listarJustificativa(){

    this.justificationService.listarJustificativa().then((retorno:any)=>{

      this.justificativa.data = retorno;
      this.justificativa.sort = this.sortJustificativa;
    },
    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Justificativa')

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }

  //Criar Justificativa (Botão Salvar)
  public criarJustificativa():void{

    if( this.formJustificativa.get("justDsJustificativa").value == ""){
      this.toastr.error('Preencha todos os campos obrigatórios antes de salvar', 'Obrigatoriedade')
      return
    }

    var dhInativo = null;

    if(this.formJustificativa.value.justDhInativo == true){
      dhInativo = '1900-01-01T00:00:00' //preencher para o backend pega o getDate()
    }

    this.beanJustificativa = new BeanJustificativa(null, null, null, null);
    this.beanJustificativa = this.formJustificativa.value;

    this.beanJustificativa.justDhInativo = dhInativo;


    if(this.formJustificativa.value.justIdCdJustificativa != '' && this.formJustificativa.value.justIdCdJustificativa > 0){

      //Editar Justificativa
      this.justificationService.updateJustificativa(this.beanJustificativa).then(()=>{

        this.toastr.success(' Atualizado com sucesso', 'SUCESSO AO ATUALIZAR')
        this.listarJustificativa();
        this.clearJustificativa();

      },
        errorResponse => {
        console.log(errorResponse)
        this.toastr.error(' Erro ao Atualizar Justificativa', 'ERRO AO ATUALIZAR')


      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });

    }else{

      //Criar nova Justificativa
      this.justificationService.addJustificativa(this.beanJustificativa).then(()=>{

        this.toastr.success(' Inserido com sucesso', 'SUCESSO AO GRAVAR')
        this.listarJustificativa();
        this.clearJustificativa();

      },
        errorResponse => {
          console.log(errorResponse)
          this.toastr.error(' Erro ao gravar Justificativa', 'ERRO AO GRAVAR')

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });
    }
  }

  //Limpar form (Botão Cancelar)
  clearJustificativa(){

    this.formJustificativa.controls['justIdCdJustificativa'].setValue("");
    this.formJustificativa.controls['justDsJustificativa'].setValue("");
    this.formJustificativa.controls['justDhInativo'].setValue("");

    this.isReadonly = false;;
  }

  //--------------------------------------- | JUSTIFICATIVA - FIM | --------------------------------------- \\




  //ABAIXO INFORMAÇÕES QUE JÁ ESTAVAM E NÃO FAÇO IDEIA SE VAI PRECISAR


  public preencheCmbOperacao(){
    
    this.addNovoFormulario();

    this.cadastroUsuarioService.getListcmbOperacao().then((retorno:BeanOperacao[])=>{

        this.lstCmbOperacao = retorno;

    }, errorResponse => {

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO PRODUTOS');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });

  }

  onChangeOperacao(event){

    this.addNovoFormulario();

    if(this.formulario.get('operacao').value > 0){

      this.formulario.get('idForm').setValue("");
      this.limparTudo();

      this.listarFichasPorOperacao(this.formulario.get('operacao').value, event);
    }
    
  }

  onChangeForm(valorSelecionado : any){

    this.limparTudo();

    this.validaEdicaoDoFormulario();

    if(valorSelecionado.value == 0){
      this.formulario.get('idForm').setValue(valorSelecionado.value);
      this.disabledTab = false;

    }else if(valorSelecionado.value >= 0){

      this.aoMudarSubMenu(0, 0, null); // 0 fichas de monitoria e

      this.formulario.get('idForm').setValue(valorSelecionado.value);

      //PREENCHER COMBOS APENAS SE FOR NOVA EDIÇÃO DO FORMULARIO
      if(this.podeAlterarFormulario == true){
        this.aoMudarSubMenu(this.indexMenu, this.indexSubMenu, null);
      }
        
      this.disabledTab = false;


    }else{
      this.disabledTab = true;
    }
  }


  validaEdicaoDoFormulario(){

      this.cadastroFichaMonitoriaService.listaFormularioPossuiMonitoria(this.formulario.get('idForm').value).subscribe( retorno => {
          
          if(retorno == null){
            this.podeAlterarFormulario = true;
          }else if(retorno.formIdCdFormulario > 0){
              this.podeAlterarFormulario = false;
          }
            
      }, errorResponse => {

        this.setSessionExpired(errorResponse);
      });

  }

  onChangeDefaultQuestionAnswer(toggle){

    if(toggle.checked){
      const idPerg = this.formulario.get('pergDsPergunta').value;
      const answerDefaultList = this.dataSourceQuestionXAnswers.filteredData.filter(f => f.pergIdCdPergunta === idPerg && f.pereInRespostaDefault === 'S');
      if(answerDefaultList.length > 0) {
        this.formulario.get('defaultPXR').setValue(false);
        return this.toastr.error('Já existe um valor default cadastrado para esta pergunta','Pergunta X Resposta');
      }
    }

  }

  public listarFormulario(){

    this.cadastroFichaMonitoriaService.listaFormulario(this.formulario.get('idForm').value).subscribe( retorno => {
      this.dataSourceFicha.data = retorno;

      this.dataSourceFormularioAux  = retorno;

      this.setForm(retorno);
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }

  public listarCabecalho(){

    this.limparTudo();

    this.cadastroFichaMonitoriaService.listarCabecalho(this.formulario.get('idForm').value).subscribe( retorno => {
      this.dataSourceParametro = new MatTableDataSource<BeanParameter>(retorno);

      this.lstBeanParameter = retorno;

      //add para preencher quando possui motivo
      this.lstBeanParameter.forEach(parameter => {

        parameter.isPossuiMotivo = false;

        if( this.lstBeanCabecalhoMotivoCadastro.find(motivo => motivo.paraIdCdParametro === parameter.paraIdCdParametro)){

          parameter.isPossuiMotivo = true;

        }

      });





      this.dataSourceParametro.sort = this.sortCabecalho;


    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }

  public listarMotivo(){

    this.limparTudo();

    this.cadastroFichaMonitoriaService.listarMotivo(this.formulario.get('idForm').value).subscribe( retorno => {
      this.dataSourceMotivo = new MatTableDataSource<BeanMotivo>(retorno);
      this.dataSourceMotivo.sort = this.sortMotivo;

      this.lstBeanMotivo = retorno;

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }


  public listarParametroXMotivo(){

    this.limparTudo();

    this.cadastroFichaMonitoriaService.listarParametroXMotivo(this.formulario.get('idForm').value).subscribe( retorno => {

      this.lstBeanCabecalhoMotivoCadastro = retorno;
      this.dataSourceParametroXMotivo = new MatTableDataSource<BeanParametroXMotivo>(retorno);
      this.dataSourceParametroXMotivo.sort = this.sortMotivo;

      this.lstBeanMotivo = retorno;

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }


  public listarGrupo(){

    this.limparTudo();

    this.cadastroFichaMonitoriaService.listarGrupo(this.formulario.get('idForm').value).subscribe( retorno => {
      this.dataSourceGrupoCategoria.data = retorno;

      this.lstBeanCategoryGroup = this.dataSourceGrupoCategoria.data.sort((a,b) => a.grcaDsGrupoCategoria.localeCompare(b.grcaDsGrupoCategoria));

      this.dataSourceGrupoCategoria.sort = this.sortGpCategoria;

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }



  public listarCmbParametro(){

    this.limparTudo();

    this.cadastroFichaMonitoriaService.listarCabecalho(this.formulario.get('idForm').value).subscribe( retorno => {

      this.lstBeanCmbParametroMot = retorno;

    }, errorResponse => {

      this.setSessionExpired(errorResponse);

    });

  }



  public listarCmbMotivo(){

    this.limparTudo();

    this.cadastroFichaMonitoriaService.listarMotivo(this.formulario.get('idForm').value).subscribe( retorno => {

      this.lstBeanCmbMotivoMot = retorno;

    }, errorResponse => {

      this.setSessionExpired(errorResponse);

    });

  }



  public listarCategoria(){

    this.limparTudo();
    this.listarGrupo();

    this.cadastroFichaMonitoriaService.listarCategoria(this.formulario.get('idForm').value).subscribe( retorno => {
      this.dataSourceCategoria.data = retorno;

      this.lstBeanCategory = this.dataSourceCategoria.data.sort((a,b) => a.cateDsCategoria.localeCompare(b.cateDsCategoria));

      this.dataSourceCategoria.sort = this.sortCategoria;

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }

  public listarRespostas(){

    this.limparTudo();

    this.cadastroFichaMonitoriaService.listarRespostas(this.formulario.get('idForm').value).subscribe( retorno => {
      this.dataSourceResposta.data = retorno;

      this.lstBeanAnswer = this.dataSourceResposta.data.sort((a,b) => a.respDsResposta.localeCompare(b.respDsResposta));

      this.dataSourceResposta.sort = this.sortResposta;
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }

  public listarPerguntas(){

    this.limparTudo();

    this.cadastroFichaMonitoriaService.listarPerguntas(this.formulario.get('idForm').value).subscribe( retorno => {
      this.dataSourcePergunta.data = retorno;

      this.lstBeanQuestion = this.dataSourcePergunta.data.sort((a,b) => a.pergDsPergunta.localeCompare(b.pergDsPergunta));

      this.dataSourcePergunta.sort = this.sortPergunta;
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });

    this.listarGrupo();
    this.listarCategoria();

  }

  public listaCategoriaPergunta(valorSelecionado: any){

    this.formulario.get('idCategoriaPergunta').setValue("");
    this.formulario.get('idCategoriaPergXRespa').setValue("");
    this.formulario.get('pergDsPergunta').setValue("");

    let idGrupoCategoria : string;
    if(valorSelecionado.value == undefined){
      idGrupoCategoria = valorSelecionado;
    }else{
      idGrupoCategoria = valorSelecionado.value;
    }

    this.cadastroFichaMonitoriaService.listaCategoriaPergunta(idGrupoCategoria).subscribe( retorno => {
      this.dataSourceCategoria.data = retorno;

      this.lstBeanCategory = this.dataSourceCategoria.data.sort((a,b) => a.cateDsCategoria.localeCompare(b.cateDsCategoria));
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }

  public listaPerguntaCategoria(valorSelecionado: any){

    this.formulario.get('pergDsPergunta').setValue("");

    let idCategoria : string;
    if(valorSelecionado.value == undefined){
      idCategoria = valorSelecionado;
    }else{
      idCategoria = valorSelecionado.value;
    }


      this.cadastroFichaMonitoriaService.listaPerguntaCategoria(idCategoria).subscribe( retorno => {
        this.dataSourcePergunta.data = retorno[0].questions;

        this.lstBeanQuestion = this.dataSourcePergunta.data.sort((a,b) => a.pergDsPergunta.localeCompare(b.pergDsPergunta));

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });
  }



  public changePerg(valorSelecionado: any){


    const objPergunta = this.lstBeanQuestion.filter(f => f.pergIdCdPergunta == valorSelecionado.value )[0];

    this.pergInExtraAux = objPergunta.pergInExtra;

  }



  public listarPergXResp(){

    this.limparTudo();

    this.cadastroFichaMonitoriaService.listaPergXResp(this.formulario.get('idForm').value).subscribe( retorno => {
      this.dataSourceQuestionXAnswers = new MatTableDataSource<BeanQuestionXAnswers>(retorno);

      this.lstBeanQuestionXAnswers = retorno;

      this.dataSourceQuestionXAnswers.sort = this.sortPergXResp;
    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });

    this.listarGrupo();
    //this.listarCategoria();
    //this.listarPerguntas();
    this.listarRespostas();
  }

  public listarFichasPorOperacao(idOperacao : string, event){

    let valueStatus = '';
    if(event == 'null'){
      valueStatus = this.formulario.get('formAtivo').value
    }else{
      valueStatus = event.value
    }

    this.cadastroFichaMonitoriaService.listaFormulariosPorOperacoes(idOperacao, valueStatus).subscribe( retorno => {
      this.dataSourceFicha.data = retorno;

      this.lstBeanFormulario = retorno;
    },
    errorResponse => { //CASO ERRO

      if(!this.setSessionExpired(errorResponse)){

        this.lstBeanFormulario = null;
        this.toastr.info('Não há formulários disponíveis para a operação selecionada','Lista Formulários');
      }
    });
  }

  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceFicha.filter = filterValue.trim().toLowerCase();
    this.dataSourceGrupoCategoria.filter = filterValue.trim().toLowerCase();
    this.dataSourceCategoria.filter = filterValue.trim().toLowerCase();
    this.dataSourcePergunta.filter = filterValue.trim().toLowerCase();
    this.dataSourceResposta.filter = filterValue.trim().toLowerCase();
    this.dataSourceParametro.filter = filterValue.trim().toLowerCase();
    this.dataSourceQuestionXAnswers.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceFicha.paginator) {
      this.dataSourceFicha.paginator.firstPage();
    }

    //ADICIONADO PARA A ABA CONTEÚDO GLOBAL - submenus Perfil e Status
    if(this.dataSourceProfile.paginator){
      this.dataSourceProfile.paginator.firstPage();
    }

    if(this.status.paginator){
      this.status.paginator.firstPage();
    }

    if (this.dataSourceParametro.paginator) {
      this.dataSourceParametro.paginator.firstPage();
    }

  }

  displayedColumnsFicha             : string[] = ['fichaMonitoria', 'inativoFicha'];
  displayedColumnsGrupoDeCategorias : string[] = ['grcaNrOrdem', 'grcaDsGrupoCategoria', 'grcaDhInativo'];
  displayedColumnsCategorias        : string[] = ['grcaDsGrupoCategoria', 'cateNrOrdem', 'cateDsCategoria', 'cateDhInativo'];
  displayedColumnsPerguntas         : string[] = ['grcaDsGrupoCategoria', 'cateDsCategoria', 'pergNrOrdem', 'pergDsPergunta', 'pergDhInativo'];
  displayedColumnsRespostas         : string[] = ['respNrOrdem', 'respDsResposta', 'respInNaoseaplica', 'respDhInativo'];
  displayedColumnsRespostas2         : string[] = ['grcaDsGrupoCategoria', 'cateDsCategoria', 'pergDsPergunta', 'respDsResposta', 'pereNrPonto', 'pereNrPontoExtra', 'pereInZerar', 'pereDhInativo'];
  displayedColumnsPerguntasRespostas         : string[] = ['respDsResposta', 'pontosResposta', 'defaultResposta'];

  displayedColumnsCabecalho: string[] = ['paraNrOrdem', 'paraDsParametro', 'isPossuiMotivo', 'paraInObrigatorio', 'paraDhInativo'];
  displayedColumnsMotivo: string[] = ['motiDsMotivo', 'motiDhInativo'];
  displayedColumnsParametrosXMotivo : string[] = ['paraIdCdParametro', 'motiIdCdMotivo' ];

  setFormUsuario(form: BeanFormulario){
    alert("setFormUsuario");
  }

  public cancelarPergXResp(){

    this.formulario.get('idPere').setValue("");
    //this.formulario.get('pergDsPergunta').setValue("");
    this.formulario.get('respDsResposta').setValue("");
    this.formulario.get('pontuacaoPXR').setValue("");
    this.formulario.get('pontuacaoPXRTrunfo').setValue("");
    this.formulario.controls['pontuacaoPXR'].enable();
    this.formulario.get('idGrupoCategoriaPergXResp').setValue("");
    this.formulario.get('defaultPXR').setValue(false);
    this.formulario.get('pereInZerar').setValue(false);
    this.formulario.get('zerarPXR').setValue(false);
    this.formulario.get('comentarioPXR').setValue(false);
    this.formulario.get('pereDhInativo').setValue(false);
    //this.formulario.get('idGrupoCategoriaPergXResp').setValue("");
   // this.formulario.get('idCategoriaPergXRespa').setValue("");




    this.isBloquearPontuacao = false

  }



  public deletePergXResp(idPere: number):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    this.cadastroFichaMonitoriaService.removePergXRep(idPere).subscribe( retorno => {

      this.toastr.success('Parametro X Motivo excluido com sucesso','Lista de Parametro X Motivo')
      this.cancelarPergXResp();
      this.listarPergXResp();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista De Cabeçalho');

    });

  }


  public setPergXResp(form: BeanQuestionXAnswers){

    //preencher combo CATEGORIA de acordo com o GRUPO CATEGORIA
    this.listaCategoriaPergunta(form.grcaIdCdGrupoCategoria);

    //preencher combo PEREGUNTA de acordo com A CATEGORIA
    this.listaPerguntaCategoria(form.cateIdCdCategoria);
    

    this.formulario.get('idGrupoCategoriaPergXResp').setValue(form.grcaIdCdGrupoCategoria);
    this.formulario.get('idCategoriaPergXRespa').setValue(form.cateIdCdCategoria);
    this.formulario.get('idPere').setValue(form.pereIdCdPerguntaResposta);
    this.formulario.get('pergDsPergunta').setValue(form.pergIdCdPergunta);
    this.formulario.get('respDsResposta').setValue(form.respIdCdResposta);
    this.formulario.get('pontuacaoPXR').setValue(form.pereNrPonto);
    this.formulario.get('pontuacaoPXRTrunfo').setValue(form.pereNrPontoExtra);
    this.formulario.get('defaultPXR').setValue(form.pereInRespostaDefault == "N" || null? false: true);
    this.formulario.get('zerarPXR').setValue(form.pereInZerar == "N" || null? false: true);
    this.formulario.get('comentarioPXR').setValue(form.pereInComentario == "N" || null? false: true);
    this.formulario.get('pereDhInativo').setValue(form.pereDhInativo == null? false: true);

    form.pereInZerar == "S" ? this.formulario.controls['pontuacaoPXR'].disable() : this.formulario.controls['pontuacaoPXR'].enable();

    const objPergunta = this.lstBeanQuestion.filter(f => f.pergIdCdPergunta == form.pergIdCdPergunta)[0];
    this.pergInExtraAux = objPergunta.pergInExtra;

  }

  public salvarPergXResp(){

    if(this.formulario.get('pergDsPergunta').value == "" || this.formulario.get('respDsResposta').value == "" || this.formulario.get('pontuacaoPXR').value < 0){
      return;

    }else{


      if(this.formulario.get('idPere').value == ""){

        this.createPergXResp(this.formulario.get('pergDsPergunta').value, this.formulario.get('respDsResposta').value,
              this.formulario.get('pontuacaoPXR').value, this.formulario.get('defaultPXR').value, this.formulario.get('zerarPXR').value,
                    this.formulario.get('comentarioPXR').value, this.formulario.get('pereDhInativo').value,  this.formulario.get('pontuacaoPXRTrunfo').value);

      }else{

        this.updatePergXResp(this.formulario.get('idPere').value, this.formulario.get('pergDsPergunta').value, this.formulario.get('respDsResposta').value,
        this.formulario.get('pontuacaoPXR').value, this.formulario.get('defaultPXR').value, this.formulario.get('zerarPXR').value,
              this.formulario.get('comentarioPXR').value, this.formulario.get('pereDhInativo').value,  this.formulario.get('pontuacaoPXRTrunfo').value);

      }
    }
  }

  public createPergXResp(idPergPXR: string, idRespPXR: string, pontuacaoPXR:string, defaultPXR: string, zerarPXR:string, comentarioPXR:string, inativoPXR:string, pontuacaoPXRTrunfo:string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoPXR){
      inativoPXR = this.today;
    }else{
      inativoPXR = null;
    }

    this.cadastroFichaMonitoriaService.createPergXResp(idPergPXR, idRespPXR, pontuacaoPXR, defaultPXR+""=="true"?"S":"N",zerarPXR+""=="true"?"S":"N", comentarioPXR+""=="true"?"S":"N", inativoPXR, pontuacaoPXRTrunfo).subscribe( retorno => {

      this.toastr.success('Ficha criado com sucesso','Pergunta X Resposta')
      this.cancelarPergXResp();
      this.listarPergXResp();


    },
    errorResponse => { //CASO ERRO

      if(!this.setSessionExpired(errorResponse)){

        if(errorResponse.error.message.indexOf("constraint")>-1){
          this.toastr.info('A resposta já está cadastrada para esta pergunta','Pergunta X Resposta')

        }else{
          this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Pergunta X Resposta')
        }
      }
    });

  }

  public updatePergXResp(idPere:string, idPergPXR: string, idRespPXR: string, pontuacaoPXR:string, defaultPXR: string, zerarPXR:string, comentarioPXR:string, inativoPXR:string, pontuacaoPXRTrunfo:string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoPXR){
      inativoPXR = this.today;
    }else{
      inativoPXR = null;
    }

    this.cadastroFichaMonitoriaService.updatePergXResp(idPere, idPergPXR, idRespPXR, pontuacaoPXR, defaultPXR+""=="true"?"S":"N",zerarPXR+""=="true"?"S":"N", comentarioPXR+""=="true"?"S":"N", inativoPXR,  pontuacaoPXRTrunfo).subscribe( retorno => {

      this.toastr.success('Ficha atualizada com sucesso','Pergunta X Resposta')
      this.cancelarPergXResp();
      this.listarPergXResp();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Pergunta X Resposta');

    });

  }

  public setForm(form: BeanFormulario){

    this.formulario.get('idFichaMonitoria').setValue(form.formIdCdFormulario);
    this.formulario.get('fichaMonitoria').setValue(form.formDsFormulario);
    this.formulario.get('versaoFicha').setValue(form.formDsVersao);
    this.formulario.get('segmento').setValue(form.formDsSegmento);
    this.formulario.get('tipoFormulario').setValue(form.formInTipo);
    this.formulario.get('inativoFicha').setValue(form.formDhInativo == null? false: true);

    this.formulario.get('formDsTipoPontuacao').setValue(form.formDsTipoPontuacao);
    

  }

  public formCancelar():void{

    this.disabledTab = true;

    this.limparTudo();
    this.formulario.get('idForm').setValue("");

  }

  public limparTudo(){

    this.cancelarForm();
    this.cancelarCabecalho();
    this.cancelarMotivo();
    this.cancelarParametroXMotivo();
    

    this.cancelarGpCategoria();
    this.cancelarCategoria();
    this.cancelarPerguntas();
    this.cancelarRespostas();
    this.cancelarPergXResp();

    this.lstBeanCategoryGroup = [];
    this.lstBeanCategory = [];
    this.lstBeanQuestion = [];
    this.lstBeanAnswer = [];
    this.lstBeanParameter = [];
    this.lstBeanQuestionXAnswers = [];

    this.dataSourceGrupoCategoria = new MatTableDataSource<BeanCategoryGroup>();
    this.dataSourceCategoria = new MatTableDataSource<BeanCategory>();
    this.dataSourcePergunta = new MatTableDataSource<BeanQuestion>();
    this.dataSourceResposta = new MatTableDataSource<BeanAnswer>();
    this.dataSourceParametro = new MatTableDataSource<BeanParameter>(this.lstBeanParameter);
    this.dataSourceQuestionXAnswers = new MatTableDataSource<BeanQuestionXAnswers>(this.lstBeanQuestionXAnswers);
  }

  public cancelarForm(){

    this.formulario.get('idFichaMonitoria').setValue("");
    //this.formulario.get('fichaMonitoria').setValue("");
    this.formulario.get('versaoFicha').setValue("");
    this.formulario.get('segmento').setValue("");
    this.formulario.get('inativoFicha').setValue(false);
    this.formulario.get('pergInRespostasemlista').setValue(false);

  }

  public setCabecalho(form: BeanParameter){

    this.formulario.get('idFormParametro').setValue(form.formIdCdFormulario);
    this.formulario.get('idParametro').setValue(form.paraIdCdParametro);
    this.formulario.get('paraDsParametro').setValue(form.paraDsParametro);
    this.formulario.get('paraInObrigatorio').setValue(form.paraInObrigatorio == "S"? true: false);
    this.formulario.get('paraDhInativo').setValue(form.paraDhInativo == null? false: true);
    this.formulario.get('paraNrOrdem').setValue(form.paraNrOrdem);


  }

  public cancelarCabecalho():void{

    this.formulario.get('idFormParametro').setValue("");
    this.formulario.get('idParametro').setValue("");
    this.formulario.get('paraDsParametro').setValue("");
    this.formulario.get('paraInObrigatorio').setValue(false);
    this.formulario.get('paraDhInativo').setValue(false);
    this.formulario.get('paraNrOrdem').setValue("");
  }


  public setMotivo(form: BeanMotivo){

    this.formulario.get('motivoformIdCdFormulario').setValue(form.formIdCdFormulario);
    this.formulario.get('motiIdCdMotivo').setValue(form.motiIdCdMotivo);
    this.formulario.get('motiDsMotivo').setValue(form.motiDsMotivo);
    this.formulario.get('motiDhRegistro').setValue(form.motiDhRegistro);
    this.formulario.get('motiDhInativo').setValue(form.motiDhInativo == null? false: true);

  }

  public cancelarMotivo():void{

    this.formulario.get('motivoformIdCdFormulario').setValue("");
    this.formulario.get('motiIdCdMotivo').setValue("");
    this.formulario.get('motiDsMotivo').setValue("");
    this.formulario.get('motiDhRegistro').setValue(false);
    this.formulario.get('motiDhInativo').setValue(false);

  }


  public setParametroXMotivo(form: BeanParametroXMotivo){

    this.formulario.get('mopaIdCdMotivoParametro').setValue(form.mopaIdCdMotivoParametro);
    this.formulario.get('paraIdCdParametroMotivo').setValue(form.parameter.paraIdCdParametro);
    this.formulario.get('motiIdCdMotivoMotivo').setValue(form.motive.motiIdCdMotivo);

  }


  public cancelarParametroXMotivo():void{

    this.formulario.get('mopaIdCdMotivoParametro').setValue("");
    this.formulario.get('paraIdCdParametroMotivo').setValue("");
    this.formulario.get('motiIdCdMotivoMotivo').setValue("");

  }

  public setGpCategoria(form: BeanCategoryGroup):void{

    this.formulario.get('idFormGpCategoria').setValue(form.formIdCdFormulario);
    this.formulario.get('idGrupoCategoria').setValue(form.grcaIdCdGrupoCategoria);
    this.formulario.get('grcaDsGrupoCategoria').setValue(form.grcaDsGrupoCategoria);
    this.formulario.get('grcaInMapeamento').setValue(form.grcaInMapeamento == 'S'? true: false);
    this.formulario.get('grcaDhInativo').setValue(form.grcaDhInativo == null? false: true);
    this.formulario.get('grcaNrOrdem').setValue(form.grcaNrOrdem);
  }

  public cancelarGpCategoria():void{

    this.formulario.get('idFormGpCategoria').setValue("");
    this.formulario.get('idGrupoCategoria').setValue("");
    this.formulario.get('grcaDsGrupoCategoria').setValue("");
    this.formulario.get('grcaInMapeamento').setValue("");
    this.formulario.get('grcaDhInativo').setValue(false);
     this.formulario.get('grcaNrOrdem').setValue("");
  }

  public setCategoria(form: BeanCategory):void{

    this.formulario.get('idGrcaCategoria').setValue(form.grcaIdCdGrupoCategoria);
    this.formulario.get('idCategoria').setValue(form.cateIdCdCategoria);
    this.formulario.get('cateDsCategoria').setValue(form.cateDsCategoria);
    this.formulario.get('cateDhInativo').setValue(form.cateDhInativo == null? false: true);
    this.formulario.get('cateNrOrdem').setValue(form.cateNrOrdem);
  }

  public cancelarCategoria():void{

    this.formulario.get('idGrcaCategoria').setValue("");
    this.formulario.get('idCategoria').setValue("");
    this.formulario.get('cateDsCategoria').setValue("");
    this.formulario.get('cateDhInativo').setValue(false);
    this.formulario.get('cateNrOrdem').setValue("");
  }

  public setPerguntas(form: BeanQuestion):void{

    this.formulario.get('idGrupoCategoriaPergunta').setValue(form.grcaIdCdGrupoCategoria);
    this.formulario.get('idCategoriaPergunta').setValue(form.cateIdCdCategoria);
    this.formulario.get('idPergunta').setValue(form.pergIdCdPergunta);
    this.formulario.get('pergDsPergunta').setValue(form.pergDsPergunta);
    this.formulario.get('descricaoPergunta').setValue(form.pergDsObservacao);
    this.formulario.get('pergDhInativo').setValue(form.pergDhInativo == null? false: true);
    this.formulario.get('pergNrOrdem').setValue(form.pergNrOrdem);
    this.formulario.get('pergInExtra').setValue(form.pergInExtra == 'S'? true : false );
    this.formulario.get('pergInRespostasemlista').setValue(form.pergInRespostasemlista == 'S'? true : false );

  }

  public cancelarPerguntas():void{

    this.formulario.get('idGrupoCategoriaPergunta').setValue("");
    this.formulario.get('idCategoriaPergunta').setValue("");
    this.formulario.get('idPergunta').setValue("");
    this.formulario.get('pergDsPergunta').setValue("");
    this.formulario.get('descricaoPergunta').setValue("");
    this.formulario.get('pergDhInativo').setValue(false);
    this.formulario.get('pergNrOrdem').setValue("");
    this.formulario.get('pergInRespostasemlista').setValue(false);
  }

  public setRespostas(form: BeanAnswer):void{

    this.formulario.get('idResposta').setValue(form.respIdCdResposta);
    this.formulario.get('respDsResposta').setValue(form.respDsResposta);
    this.formulario.get('respDhInativo').setValue(form.respDhInativo == null? false: true);
    this.formulario.get('respInNaoseaplica').setValue(form.respInNaoseaplica == 'S'? true: false);

    this.formulario.get('respNrOrdem').setValue(form.respNrOrdem);
  }

  public cancelarRespostas():void{

    this.formulario.get('idResposta').setValue("");
    this.formulario.get('respDsResposta').setValue("");
    this.formulario.get('respDhInativo').setValue(false);
    this.formulario.get('respInNaoseaplica').setValue(false);
    this.formulario.get('respNrOrdem').setValue("");
  }

  public formSalvar():void{

    if(this.formulario.get('fichaMonitoria').value == "" || this.formulario.get('versaoFicha').value == "" ||
          this.formulario.get('segmento').value == "" || this.formulario.get('operacao').value == ""){
            return;
    }else{


      /*console.log("Formulário: Enviando : "+this.formulario.get('fichaMonitoria').value+ "; " + this.formulario.get('versaoFicha').value+ "; " + this.formulario.get('segmento').value+ "; " +
                                              this.formulario.get('operacao').value+ "; " + this.formulario.get('tipoFormulario').value+ "; " + this.formulario.get('inativoFicha').value
                                              + "; " + this.formulario.get('formDsTipoPontuacao').value+ "; " + this.formulario.get('pergInRespostasemlista').value);
      */

      if(this.formulario.get('idFichaMonitoria').value == ""){

        this.createFormulario(this.formulario.get('fichaMonitoria').value, this.formulario.get('versaoFicha').value,
              this.formulario.get('segmento').value, this.formulario.get('operacao').value, this.formulario.get('tipoFormulario').value,
              this.formulario.get('inativoFicha').value, this.formulario.get('formDsTipoPontuacao').value);

      }else{

        this.updateFormulario(this.formulario.get('idFichaMonitoria').value, this.formulario.get('fichaMonitoria').value,
              this.formulario.get('versaoFicha').value, this.formulario.get('segmento').value,
                    this.formulario.get('operacao').value, this.formulario.get('tipoFormulario').value,
                    this.formulario.get('inativoFicha').value, this.formulario.get('formDsTipoPontuacao').value);

      }
    }
  }

  public createFormulario(fichaMonitoria: string, versaoFicha: string, segmento: string, operacao: string, tipoFormulario: string, inativoFicha: string, formDsTipoPontuacao: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoFicha){
      inativoFicha = this.today;
    }else{
        inativoFicha = null;
    }

    this.cadastroFichaMonitoriaService.createFormulario(fichaMonitoria, versaoFicha, segmento, operacao, tipoFormulario, inativoFicha, formDsTipoPontuacao).subscribe( retorno => {

      this.toastr.success('Ficha criada com sucesso','Lista Fichas')
      this.listarFichasPorOperacao(operacao, 'null');
      this.listarFormulario();
      this.formCancelar();


    },
    errorResponse => { //CASO ERRO

      console.log(fichaMonitoria+"; "+ versaoFicha+"; "+  segmento+"; "+  operacao+"; "+  tipoFormulario+"; "+  inativoFicha +"; "+ formDsTipoPontuacao +"; Error: "+errorResponse );

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Fichas');

    });

  }

  public updateFormulario(idFicha:string, fichaMonitoria: string, versaoFicha: string, segmento: string, operacao: string, tipoFormulario: string, inativoFicha: string, formDsTipoPontuacao: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoFicha){
      inativoFicha = this.today;
    }else{
        inativoFicha = null;
    }

    this.cadastroFichaMonitoriaService.updateFormulario(idFicha, fichaMonitoria, versaoFicha, segmento, operacao, tipoFormulario, inativoFicha, formDsTipoPontuacao).subscribe( retorno => {

      this.toastr.success('Ficha atualizada com sucesso','Lista Fichas')
      this.listarFormulario();
    },
    errorResponse => { //CASO ERRO

      console.log(fichaMonitoria+"; "+ versaoFicha+"; "+  segmento+"; "+  operacao+"; "+  tipoFormulario+"; "+  inativoFicha +"; "+ formDsTipoPontuacao +"; Error: "+errorResponse );

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Fichas');

    });

  }

  public salvarCabecalho(){

    if(this.formulario.get('idForm').value == "" || this.formulario.get('paraDsParametro').value == ""  || this.formulario.get('paraNrOrdem').value == ""){
      this.toastr.error('Preencha os campos obrigatórios','Validação')
      return;

    }else{

      console.log("Cabçalho: Enviando : "+this.formulario.get('idForm').value, this.formulario.get('paraDsParametro').value + "; " +
                   this.formulario.get('paraInObrigatorio').value + "; " + this.formulario.get('paraDhInativo').value + "; " + this.formulario.get('paraNrOrdem').value);

      if(this.formulario.get('idParametro').value == ""){



        this.createCabecalho(this.formulario.get('idForm').value, this.formulario.get('paraDsParametro').value,
                              this.formulario.get('paraInObrigatorio').value, this.formulario.get('paraDhInativo').value,
                                this.formulario.get('paraNrOrdem').value);

      }else{

        this.updateCabecalho(this.formulario.get('idParametro').value, this.formulario.get('idForm').value,
                              this.formulario.get('paraDsParametro').value, this.formulario.get('paraInObrigatorio').value,
                                this.formulario.get('paraDhInativo').value,
                                  this.formulario.get('paraNrOrdem').value);

      }
    }
  }


  public createMotivo(idFormulario: string, motivo: string, inativoMotivo: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoMotivo){
      inativoMotivo = this.today;
    }else{
      inativoMotivo = null;
    }

    this.cadastroFichaMonitoriaService.createMotivo(idFormulario, motivo, inativoMotivo).subscribe( retorno => {

      this.toastr.success('Motivo criado com sucesso','Lista De Cabeçalho')
      this.cancelarMotivo();
      this.listarMotivo();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista De Cabeçalho');

    });

  }

  public updateMotivo(motiIdCdMotivo:string, idFormParametro: string, motiDsMotivo: string, motiDhInativo: string){

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(motiDhInativo){
      motiDhInativo = this.today;
    }else{
      motiDhInativo = null;
    }

    this.cadastroFichaMonitoriaService.updateMotivo(motiIdCdMotivo, idFormParametro, motiDsMotivo, motiDhInativo).subscribe( retorno => {

      this.toastr.success('Ficha atualizada com sucesso','Lista Fichas');
      this.cancelarMotivo();
      this.listarMotivo();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Fichas');

    });

  }









  public createParametroXMotivo(idFormulario : string, idParametro: string, idmotivo: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    this.cadastroFichaMonitoriaService.createParametroXMotivo(idFormulario, idParametro, idmotivo).subscribe( retorno => {

      this.toastr.success('Parametro X Motivo criado com sucesso','Lista de Parametro X Motivo')
      this.cancelarParametroXMotivo();
      this.listarParametroXMotivo();

    },
    errorResponse => { //CASO ERRO

      console.log(idFormulario +"; "+ idParametro +"; "+ idmotivo +"; Error: "+errorResponse );

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista De Cabeçalho');

    });

  }


  public deleteParametroXMotivo(mopaIdCdMotivoParametro: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    this.cadastroFichaMonitoriaService.removeParametroXMotivo(mopaIdCdMotivoParametro).subscribe( retorno => {

      this.toastr.success('Parametro X Motivo excluido com sucesso','Lista de Parametro X Motivo')
      this.cancelarParametroXMotivo();
      this.listarParametroXMotivo();

    },
    errorResponse => { //CASO ERRO

      console.log(mopaIdCdMotivoParametro +"; Error: "+errorResponse );

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista De Cabeçalho');

    });

  }



  public updateParameterXMotivo(mopaIdCdMotivoParametro: string, idFormulario: string, idParametro: string, idmotivo: string){

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');


    this.cadastroFichaMonitoriaService.updateParametroXMotivo(mopaIdCdMotivoParametro, idFormulario, idParametro, idmotivo).subscribe( retorno => {

      this.toastr.success('Ficha atualizada com sucesso','Lista Fichas');
      this.cancelarMotivo();
      this.listarMotivo();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Fichas');

    });

  }













  public salvarMotivo(){

    if(this.formulario.get('idForm').value == "" || this.formulario.get('motiDsMotivo').value == ""){
      return;

    }else{

      if(this.formulario.get('motiIdCdMotivo').value == ""){

        this.createMotivo(this.formulario.get('idForm').value,
              this.formulario.get('motiDsMotivo').value, this.formulario.get('motiDhInativo').value);

      }else{

        this.updateMotivo(this.formulario.get('motiIdCdMotivo').value, this.formulario.get('idForm').value,
              this.formulario.get('motiDsMotivo').value, this.formulario.get('motiDhInativo').value);

      }
    }
  }



  public salvarCabecalhoXMotivo(){




    if(this.formulario.get('idForm').value == "" || this.formulario.get('paraIdCdParametroMotivo').value == "" || this.formulario.get('motiIdCdMotivoMotivo').value == ""){
      return;

    }else{


      // VALIDAR SE O ITEM JÁ ESTÁ NA LISTA
      for(var itemCabecalhoMotivo of this.dataSourceParametroXMotivo.filteredData ){

        if(itemCabecalhoMotivo.parameter.paraIdCdParametro == this.formulario.get('paraIdCdParametroMotivo').value
            && itemCabecalhoMotivo.motive.motiIdCdMotivo == this.formulario.get('motiIdCdMotivoMotivo').value){

              this.toastr.show('Item já está na lista','Parametro X Motivo')
              this.cancelarParametroXMotivo();

              return;
        }

      }


      if(this.formulario.get('mopaIdCdMotivoParametro').value == ""){

        this.createParametroXMotivo(
          this.formulario.get('idForm').value, this.formulario.get('paraIdCdParametroMotivo').value, this.formulario.get('motiIdCdMotivoMotivo').value
              );

      }else{

        this.updateParameterXMotivo(this.formulario.get('motiIdCdMotivo').value, this.formulario.get('idForm').value,
              this.formulario.get('paraIdCdParametroMotivo').value, this.formulario.get('motiIdCdMotivoMotivo').value);

      }
    }
  }







  public createCabecalho(idFormParametro: string, parametro: string, inObrigatorio:string, inativoParametro: string, paraNrOrdem: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoParametro){
      inativoParametro = this.today;
    }else{
      inativoParametro = null;
    }

    this.cadastroFichaMonitoriaService.createCabecalho(idFormParametro, parametro, inObrigatorio+""=="true"?"S":"N", inativoParametro, paraNrOrdem).subscribe( retorno => {

      this.toastr.success('Cabeçalho criado com sucesso','Lista De Cabeçalho')
      this.cancelarCabecalho();
      this.listarCabecalho();

    },
    errorResponse => { //CASO ERRO

      console.log(idFormParametro +"; "+ parametro +"; "+ (inObrigatorio+""=="true"?"S":"N") +"; "+ inativoParametro +"; "+ paraNrOrdem +"; Error: "+errorResponse );
      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista De Cabeçalho');

    });

  }


  public updateCabecalho(idParametro:string, idFormParametro: string, parametro: string, inObrigatorio:string, inativoParametro: string, paraNrOrdem: string){

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoParametro){
      inativoParametro = this.today;
    }else{
      inativoParametro = null;
    }

    this.cadastroFichaMonitoriaService.updateCabecalho(idParametro, idFormParametro, parametro, inObrigatorio+""=="true"?"S":"N", inativoParametro, paraNrOrdem).subscribe( retorno => {

      this.toastr.success('Ficha atualizada com sucesso','Lista Fichas');
      this.cancelarCabecalho();
      this.listarCabecalho();

    },
    errorResponse => { //CASO ERRO
      console.log(idFormParametro +"; "+ parametro +"; "+ (inObrigatorio+""=="true"?"S":"N") +"; "+ inativoParametro +"; "+ paraNrOrdem +"; Error: "+errorResponse );

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista Fichas');

    });

  }


















  public salvarGrupo():void{

    if(this.formulario.get('idForm').value == "" || this.formulario.get('grcaDsGrupoCategoria').value == ""
        || this.formulario.get('grcaNrOrdem').value == "" || this.formulario.get('grcaNrOrdem').value == null){

      this.toastr.error('Preencha os campos obrigatórios','Validação')
      return;

    }else{

      if(this.formulario.get('idGrupoCategoria').value == ""){

        this.createGrupo(this.formulario.get('idForm').value, this.formulario.get('grcaDsGrupoCategoria').value,
                          this.formulario.get('grcaInMapeamento').value == true ? 'S' : 'N', this.formulario.get('grcaDhInativo').value
                          , this.formulario.get('grcaNrOrdem').value);

      }else{

        this.updateGrupo(this.formulario.get('idGrupoCategoria').value, this.formulario.get('idForm').value,
                          this.formulario.get('grcaInMapeamento').value == true ? 'S' : 'N', this.formulario.get('grcaDsGrupoCategoria').value,
                          this.formulario.get('grcaDhInativo').value, this.formulario.get('grcaNrOrdem').value);

      }

    }

  }

  public createGrupo(idFormParametro: string, grupoCategoria: string, grcaInMapeamento: string, inativoGrupoCategoria: string, nrOrdem: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoGrupoCategoria){
      inativoGrupoCategoria = this.today;
    }else{
      inativoGrupoCategoria = null;
    }

    this.cadastroFichaMonitoriaService.createGrupoCategoria(idFormParametro, grupoCategoria, grcaInMapeamento, inativoGrupoCategoria, nrOrdem).subscribe( retorno => {

      this.toastr.success('Grupo categoria criado com sucesso','Lista de Grupo Categoria')
      this.cancelarGpCategoria();
      this.listarGrupo();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista de Grupo Categoria');

    });

  }

  public updateGrupo(idGrupoCategoria:string, idFormGpCategoria: string, grcaInMapeamento :string, grupoCategoria: string, inativoGrupoCategoria: string, nrOrdem: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoGrupoCategoria){
      inativoGrupoCategoria = this.today;
    }else{
      inativoGrupoCategoria = null;
    }

    this.cadastroFichaMonitoriaService.updateGrupoCategoria(idGrupoCategoria, idFormGpCategoria, grupoCategoria, grcaInMapeamento, inativoGrupoCategoria, nrOrdem).subscribe( retorno => {

      this.toastr.success('Grupo Categoria atualizada com sucesso','Lista de Lista de Grupo Categoria')
      this.cancelarGpCategoria();
      this.listarGrupo();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista de Grupo Categoria')

    });

  }

  public salvarCategoria():void{

    if(this.formulario.get('idGrcaCategoria').value == "" || this.formulario.get('cateDsCategoria').value == ""
    || this.formulario.get('cateNrOrdem').value == "" || this.formulario.get('cateNrOrdem').value == null){

      this.toastr.error('Preencha os campos obrigatórios','Validação')
      return;

    }else{

      if(this.formulario.get('idCategoria').value == ""){

        this.createCategoria(this.formulario.get('idGrcaCategoria').value, this.formulario.get('cateDsCategoria').value,
              this.formulario.get('cateDhInativo').value, this.formulario.get('cateNrOrdem').value);

      }else{

        this.updateCategoria(this.formulario.get('idCategoria').value, this.formulario.get('idGrcaCategoria').value,
              this.formulario.get('cateDsCategoria').value, this.formulario.get('cateDhInativo').value, this.formulario.get('cateNrOrdem').value);

      }
    }
  }

  public createCategoria(idGrcaCategoria: string, categoria: string, inativoCategoria: string, nrOrdem: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoCategoria){
      inativoCategoria = this.today;
    }else{
      inativoCategoria = null;
    }

    this.cadastroFichaMonitoriaService.createCategoria(idGrcaCategoria, categoria, inativoCategoria, nrOrdem).subscribe( retorno => {

      this.toastr.success('Categoria criado com sucesso','Lista de Categoria')
      this.cancelarCategoria();
      this.listarCategoria();

    },
    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista de Categoria');

    });

  }

  public updateCategoria(idCategoria:string, idGrcaCategoria: string, categoria: string, inativoCategoria: string, nrOrdem: string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoCategoria){
      inativoCategoria = this.today;
    }else{
      inativoCategoria = null;
    }

    this.cadastroFichaMonitoriaService.updateCategoria(idCategoria, idGrcaCategoria, categoria, inativoCategoria, nrOrdem).subscribe( retorno => {

      this.toastr.success('Categoria atualizada com sucesso','Lista de Categoria')
      this.cancelarCategoria();
      this.listarCategoria();

    },
    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista de Categoria');

    });

  }

  public salvarPerguntas():void{

    if(this.formulario.get('idCategoriaPergunta').value == "" || this.formulario.get('pergDsPergunta').value == ""
        || this.formulario.get('pergDsPergunta').value == ""  || this.formulario.get('pergNrOrdem').value == ""
        || this.formulario.get('pergNrOrdem').value == null){

          this.toastr.error('Preencha os campos obrigatórios','Validação')
         return;

    }else{


      console.log(this.formulario.get('pergInExtra').value)

      if(this.formulario.get('idPergunta').value == ""){

        this.createPerguntas(this.formulario.get('idCategoriaPergunta').value, this.formulario.get('pergDsPergunta').value,
              this.formulario.get('descricaoPergunta').value, this.formulario.get('pergDhInativo').value,
              this.formulario.get('pergNrOrdem').value, (this.formulario.get('pergInExtra').value == true ? 'S' : 'N' ), (this.formulario.get('pergInRespostasemlista').value == true ? 'S' : 'N' ));

      }else{

        this.updatePerguntas(this.formulario.get('idPergunta').value, this.formulario.get('idCategoriaPergunta').value,
              this.formulario.get('pergDsPergunta').value, this.formulario.get('descricaoPergunta').value, this.formulario.get('pergDhInativo').value,
              this.formulario.get('pergNrOrdem').value, (this.formulario.get('pergInExtra').value == true ? 'S' : 'N' ), (this.formulario.get('pergInRespostasemlista').value == true ? 'S' : 'N' ));

      }
    }
  }

  public createPerguntas(idCategoriaPergunta: string, pergunta: string, descricaoPergunta: string, inativoPergunta:string, nrOrdem: string, inExtra: string, pergInRespostasemlista :string ):void{
 
    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoPergunta){
      inativoPergunta = this.today;
    }else{
      inativoPergunta = null;
    }


    this.cadastroFichaMonitoriaService.createPergunta(idCategoriaPergunta, pergunta, descricaoPergunta, inativoPergunta, nrOrdem, inExtra, pergInRespostasemlista).subscribe( retorno => {

      this.toastr.success('Pergunta criada com sucesso','Lista de Perguntas')
      this.cancelarPerguntas();
      this.listarPerguntas();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista de Perguntas');

    });

  }

  public updatePerguntas(idPergunta:string, idCategoriaPergunta: string, pergunta: string, descricaoPergunta: string, inativoPergunta:string, nrOrdem: string, inExtra: string, pergInRespostasemlista : string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoPergunta){
      inativoPergunta = this.today;
    }else{
      inativoPergunta = null;
    }

    this.cadastroFichaMonitoriaService.updatePergunta(idPergunta, idCategoriaPergunta, pergunta, descricaoPergunta, inativoPergunta, nrOrdem, inExtra, pergInRespostasemlista).subscribe( retorno => {

      this.toastr.success('Pergunta atualizada com sucesso','Lista de Perguntas')
      this.cancelarPerguntas();
      this.listarPerguntas();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista de Perguntas');

    });

  }

  public salvarRespostas():void{

    if(this.formulario.get('respDsResposta').value == "" || this.formulario.get('respNrOrdem').value == ""
        || this.formulario.get('respNrOrdem').value == null){

          this.toastr.error('Preencha os campos obrigatórios','Validação')
      return;

    }else{

      if(this.formulario.get('idResposta').value == ""){

        this.createRespostas(this.formulario.get('respDsResposta').value, this.formulario.get('respDhInativo').value, this.formulario.get('respNrOrdem').value, this.formulario.get('respInNaoseaplica').value  == true ? 'S' : 'N');

      }else{

        this.updateRespostas(this.formulario.get('idResposta').value, this.formulario.get('respDsResposta').value,
              this.formulario.get('respDhInativo').value, this.formulario.get('respNrOrdem').value, this.formulario.get('respInNaoseaplica').value == true ? 'S' : 'N'  );

      }
    }
  }

  public createRespostas(resposta: string, inativoResposta: string, nrOrdem: string, respInNaoseaplica:string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoResposta){
      inativoResposta = this.today;
    }else{
      inativoResposta = null;
    }

    this.cadastroFichaMonitoriaService.createResposta(this.formulario.get('idForm').value,resposta, inativoResposta, nrOrdem, respInNaoseaplica).subscribe( retorno => {

      this.toastr.success('Resposta criada com sucesso','Lista de Respostas')
      this.cancelarRespostas();
      this.listarRespostas();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista de Respostas');

    });

  }

  public updateRespostas(idResposta:string, resposta: string, inativoResposta: string, nrOrdem: string, respInNaoseaplica:string):void{

    this.today = this.datePipe.transform( new Date(),'yyyy-MM-ddThh:mm');

    if(inativoResposta){
      inativoResposta = this.today;
    }else{
      inativoResposta = null;
    }

    this.cadastroFichaMonitoriaService.updateResposta(this.formulario.get('idForm').value,idResposta, resposta, inativoResposta, nrOrdem, respInNaoseaplica).subscribe( retorno => {

      this.toastr.success('Resposta atualizada com sucesso','Lista de Respostas')
      this.cancelarRespostas();
      this.listarRespostas();

    },
    errorResponse => { //CASO ERRO

      this.setSessionExpired(errorResponse) ? true : this.toastr.error('Erro ao conectar Backend.\nComunique suporte sistemas.','Lista de Respostas');

    });

  }

  loadDialogPreviaFormulario(){

    const dialogRef = this.dialog.open(DialogPreviaFormulario,{
      width: '100vw',
      maxWidth: '100vw',
      data: {
        idFormulario: this.formulario.controls.idForm.value
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if(result != undefined && result != null){

        if(result.sessionExpired){

          this.sessionExpired = result.sessionExpired;
          this.resetSessionExpired();
        }

      }
    });

  }


  loadDialogDuplicarFormulario(){

    let  dialogTitle = 'Deseja duplicar o formulário [ '+this.formulario.controls.fichaMonitoria.value+'] ?';
    let dialogText = 'Após a confirmação desta ação não poderá ser desfeita.';

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        dialogTitle: dialogTitle,
        dialogText: dialogText 
      }, width: '400px'
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result){
          
        const dialogRef = this.dialog.open(DialogDuplicarFormulario,{
          width: '50vw',
          maxWidth: '50vw',
          panelClass: 'custom-container',
          data: {
            idFormulario: this.formulario.controls.idForm.value,
            dsFormulario: this.formulario.controls.fichaMonitoria.value,            
          }
        });
    
        dialogRef.afterClosed().subscribe(result => {
    

          this.listarFichasPorOperacao(this.formulario.get('operacao').value, 'null');

          if(result != undefined && result != null){
    
            if(result.sessionExpired){
    
              this.sessionExpired = result.sessionExpired;
              this.resetSessionExpired();
            }
    
          }
          
        });
    
      }
    });




    
  }

}

@Component({
  selector: 'previaFormulario',
  templateUrl: './previaFormulario.component.html',
  styleUrls: ['../monitoria/monitoria.component.css']

})
export class DialogPreviaFormulario implements OnInit {


  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {

    event.returnValue = false;
  }

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogPreviaFormulario>,
    @Inject(MAT_DIALOG_DATA) public data: {
      idFormulario: string
    },
    private cadastroFichaMonitoriaService: CadastroFichaMonitoriaService,
    private profileService: ProfileService,
    private statusService: StatusService,
    private justificationService: JustificationService,
    private toastr: ToastrService,
    private router: Router
  ) { }


  public beanMonitoria :  BeanMonitoria = new BeanMonitoria(null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null, [], [], null, [], [],null,null);
  public beanFormulario :  BeanFormulario = new BeanFormulario(null,null,null,null,null,null,null, null,[],[],[], null);
  public lstCmbStatus : BeanStatus[]=[];
  public formContentDisabled:string = "none";
  public qtdApontamentoGrave: number = 0;
  public qtdApontamentoNaoGrave: number = 0;
  public sessionExpired: boolean = false;
  public marcadorCabecalhoMotivo: boolean = false;
  public formIdFormularioDisabled:string = "auto";
  public lstCmbPerfil : BeanPerfil[]=[];
  public formStartDisabled:string = "auto";
  public lstJustificativa: BeanJustificativa[] = [];

  public setSessionExpired(errorResponse:any) {

    if(errorResponse.status == 401){

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired(){

    if(this.sessionExpired){

      this.sessionExpired = false;

      setTimeout(() => this.dialogRef.close({sessionExpired:true}));
		}
  }

  ngOnInit(): void {


    //this.isSpinnerUpdateMonitoria = true;

    //validar se o formulario já foi selecionado para a monitoria
    if(this.data.idFormulario != null && this.data.idFormulario != '' && this.data.idFormulario != '0'){

      this.formContentDisabled = "auto"; // HABLILITAR O RESTANTE DO FORMULARIO
      this.formularioMonitoria.controls['idFormulario'].setValue(this.data.idFormulario);
      this.onChangeMontarFormulario();
    }

    this.listarStatusAtivo();
    this.listarPerfil();
    this.listarJustificativasAtivas();
  }

  public formularioMonitoria: FormGroup = new FormGroup({
    'idFormulario': new FormControl(""),
    'nrPontuacao': new FormControl(""),
    'statIdCdStatus': new FormControl(""),
    'idPerfil': new FormControl(""),
    'txAvaliador': new FormControl(""),
    'txFeedback': new FormControl(""),
    'txAvaliado': new FormControl(""),
    'txAlteracao': new FormControl(""),
    'idJustificativa': new FormControl(""),
    'txJustificativa': new FormControl(""),
    'txObservacao': new FormControl(""),
    'dsData': new FormControl(""),
    'nrHora': new FormControl("")
  })

  public sair(): void {

    this.dialogRef.close();
  }

  public listarPerfil(){

    this.profileService.listarProfiles().then((retorno:any)=>{

      this.lstCmbPerfil = retorno;


    },
    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Perfis disponíveis','Lista Perfil');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }

  public listarStatusAtivo(){

    this.statusService.listarStatusAtivos().then((retorno:any)=>{

      this.lstCmbStatus = retorno;


    },
    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Status disponíveis para a operação selecionada','Lista Formulários');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }

  public add():void{

  }

  // --- FORMA CABEÇALHO ---
  formFieldsCabecalho: BeanParameter[];
  formFieldsCabecalhoMotivo : BeanParametroXMotivo[];

  public formCabecalho = new FormGroup({});

  onChangeMontarFormulario(){

    // monta a ficha de monitoria [cabeçalho e perguntas]
    this.montarCamposDaFichaDinamicos();
  }

  /** METODO PARA ADICIONAR OS CAMPOS DINAMICOS DE CABEÇALHO E DE PERGUNTAS */
  public montarCamposDaFichaDinamicos(){

    let parameters;
    let parametersMotivo;

    //CARREGAR PARAMETROS ** CABEÇALHO
    this.cadastroFichaMonitoriaService.getParametersByIdForm(this.formularioMonitoria.value.idFormulario) .subscribe( retorno => {
        parameters = retorno;
      },
      errorResponse => {
        this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Parametros ativos para este formulário','Lista Parametros');
      });


      //CARREGAR PARAMETROS COM MOTIVOS ** CABEÇALHO
    this.cadastroFichaMonitoriaService.listarParametroXMotivo(this.formularioMonitoria.value.idFormulario).subscribe( retorno => {
      parametersMotivo = retorno;

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });

    this.cadastroFichaMonitoriaService.listarFormularioEspecifico(this.formularioMonitoria.value.idFormulario) .subscribe( retorno => {

      parameters = retorno.parameters;
      this.beanFormulario = retorno;

      this.beanFormulario.parametersMotivos = parametersMotivo;



      //MONTAR PERGUNTAS MARCADAS COMO DEFAULT (MARCAR COM CHECK NA TELA)
      //Correção inserido o set formulario em atualizarMonitoriaEnviandoCampo() **resposta voltando o check errado de outras perguntas quando fecha a tela de comentario sem salvar
      if(this.beanMonitoria.formIdCdFormulario != null && this.beanMonitoria.formIdCdFormulario != ""){
        //this.validaPerguntasDefault();
        //this.validaPerguntaComentada();
      }

      //CRIAR FORM CABEÇALHO
      for (const formField of this.beanFormulario.parameters) {

        let isAddControl = false;

        if(!isAddControl){
          formField.pamoIdCdParametroFormulario = 0
          let controlNameIdPara = formField.paraIdCdParametro;

          //ADICIONA AO formCabecalho OS CAMPOS RETORNADOS DO CADASTRO (apenas se não foi criado com values da PAMO)
          if(formField.paraDhInativo == null){
            this.formCabecalho.addControl(controlNameIdPara, new FormControl(''));
          }else{
            this.formCabecalho.addControl(controlNameIdPara, new FormControl(''));
          }

        }
      }




      for(let i = 0; i < this.beanFormulario.parameters.length; i++ ){

        this.beanFormulario.parameters[i].beanParametroXMotivo =[]

        if(this.beanFormulario.parametersMotivos != null && this.beanFormulario.parametersMotivos != undefined){

            for(let j = 0; j < this.beanFormulario.parametersMotivos.length; j++ ){

              if(this.beanFormulario.parameters[i].paraIdCdParametro == this.beanFormulario.parametersMotivos[j].paraIdCdParametro){

                this.beanFormulario.parameters[i].beanParametroXMotivo.push(this.beanFormulario.parametersMotivos[j])
                this.marcadorCabecalhoMotivo = true
              }
            }
        }


      }

      this.formFieldsCabecalho = this.beanFormulario.parameters;




    },

    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Status disponíveis para a operação selecionada','Lista Formulários');
    });
  }

  loadDialogParametroMotivos(beanParameter : BeanParameter){

    //preencher combo com motivos na tela
    let lstBeanMotivo : BeanMotivo[] = []
    for(let beanMotivo of this.beanFormulario.parametersMotivos){
      if(beanMotivo.paraIdCdParametro == beanParameter.paraIdCdParametro){
        lstBeanMotivo.push(beanMotivo.motive)
      }
    }

    const dialogRef = this.dialog.open(PrevParametroMotivoDialog,{
      width:'50%',
      data: {
        beanParameter: beanParameter,
        lstCmbBeanMotivo: lstBeanMotivo
      }

    });

    // dialogRef.componentInstance.lstCmbBeanMotivo = lstBeanMotivo;
    // dialogRef.componentInstance.beanParameter = beanParameter;
    // dialogRef.componentInstance.moniIdCdMonitoria = Number(this.beanMonitoria.moniIdCdMonitoria);

    // dialogRef.componentInstance.beanMonitoryParameter = this.beanMonitoria.monitoryParameter.filter(t => t.paraIdCdParametro === Number(beanParameter.paraIdCdParametro));


    dialogRef.afterClosed().subscribe(result => {

    });
  }

  public validaPerguntasDefault(){

    for (let i1 = 0; i1 < this.beanFormulario.categoryGroups.length; i1++) {
      const formGrca = this.beanFormulario.categoryGroups[i1];

      for (let i2 = 0; i2 < formGrca.categories.length; i2++) {
        const formCate = formGrca.categories[i2];

        for (let i3 = 0; i3 < formCate.questions.length; i3++) {
          const formQues = formCate.questions[i3];

          for (let i4 = 0; i4 < formQues.questionAnswers.length; i4++) {
            const formQa = formQues.questionAnswers[i4];

            this.beanFormulario.categoryGroups[i1].categories[i2].questions[i3].questionAnswers[i4].pereInRespostaDefault = "N";

            for (let k = 0; k < this.beanMonitoria.monitoryQuestionAnswers.length; k++) {
              const moniQA = this.beanMonitoria.monitoryQuestionAnswers[k];

              if(formGrca.grcaIdCdGrupoCategoria == moniQA.grcaIdCdGrupoCategoria && formCate.cateIdCdCategoria == moniQA.cateIdCdCategoria
                  && formQa.pergIdCdPergunta == moniQA.pergIdCdPergunta && moniQA.respIdCdResposta !=null && moniQA.respIdCdResposta > 0){

                if(formQa.answer.respIdCdResposta == moniQA.respIdCdResposta){
                  this.beanFormulario.categoryGroups[i1].categories[i2].questions[i3].questionAnswers[i4].pereInRespostaDefault = "S";

                  if( this.beanFormulario.categoryGroups[i1].categories[i2].questions[i3].questionAnswers[i4].pereInZerar == 'S'){
                    this.qtdApontamentoGrave++
                  }

                }




              }
            }
          }
        }
      }
    }
  }

  public listarJustificativasAtivas(){

    this.justificationService.listarJustificativasAtivas().then((retorno:any)=>{

      this.lstJustificativa = retorno;

    },
    errorResponse => { //CASO ERRO
      this.setSessionExpired(errorResponse) ? true : this.toastr.info('Não há Justificativa disponíveis','Lista Formulários');

    }).catch((retorno:any) => {

      if(retorno.error.error_description.indexOf("Access token expired")>-1){
          alert("Sessão Expirada");
          this.router.navigate(['']);
        }
    });
  }

  loadDialogObservacao(pergDsObservacao: string) {

    const dialogRef = this.dialog.open(ObservacaoMonitoriaDialog,{
      width:'50%',
      height: '50%',
      data: {
        pergDsObservacao: pergDsObservacao
      }
    });
  }
}



@Component({
  selector: 'duplicarFormulario',
  templateUrl: './duplicarFormulario.component.html',
  styleUrls: ['./duplicar.formulario.component.css', '../monitoria/monitoria.component.css']

})
export class DialogDuplicarFormulario implements OnInit {

 
    @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
  
      event.returnValue = false;
    }
  
    constructor(
      private dialog: MatDialog,
      private dialogRef: MatDialogRef<DialogPreviaFormulario>,
      @Inject(MAT_DIALOG_DATA) public data: {
        idFormulario: number,
        dsFormulario: string
      },
      private cadastroFichaMonitoriaService: CadastroFichaMonitoriaService,
      private profileService: ProfileService,
      private statusService: StatusService,
      private justificationService: JustificationService,
      private toastr: ToastrService,
      private router: Router
    ) { }

  public sessionExpired = false;
  public beanFormulario :  BeanFormulario = new BeanFormulario(null,null,null,null,null,null,null, null,[],[],[], null);
 
  // 0 aguardando / 1 processando / 2 sucesso / 3 erro
  
  ajustandoTabelas : number = 1;
  criandoFormulario : number = 0;
  criandoMotivos: number = 0;
  criandoParametros : number = 0;
  criandoVinculosDeParametrosMotivos : number = 0;
  criandoGruposCategroria : number = 0;
  criandoCategorias : number = 0;
  criandoPerguntas : number = 0;
  criandoRespostas : number = 0;
  criandoVinculosEntrePerguntasRespostas : number = 0;

  msgSucesso : boolean = false;
  msgErro : boolean = false;

  novoFormularioCriado : number = 0;  
  statusProcessamentoCompleto : number = 0; 

  ngOnInit(): void {

    /*METODO PARA CRIAR O FORMULARIO E SEUS ITENS : VARIOS METODOS*/
    //this.criarFormularioItemPorItem();

    /*METODO PARA CRIAR O FORMULARIO POR COMPLETO : UNICO METODO SINCRONIZADO*/
    this.criarFormularioCompleto();

  }




  /*METODO PARA CRIAR O FORMULARIO POR COMPLETO : UNICO METODO SINCRONIZADO*/
  criarFormularioCompleto(){

    let formularioParaCopiar: number = this.data.idFormulario;
    


    this.cadastroFichaMonitoriaService.criarFormulario_DuplicacaoDeFormularioAll(formularioParaCopiar).subscribe( retorno => { //retorno booleano
      
        //ALTERAR STATUS DA TELA
        //0 aguardando / 1 processando / 2 sucesso / 3 erro
        
        this.statusProcessamentoCompleto = 1; // processando

        if(retorno > 0){

          this.novoFormularioCriado = retorno;

          this.statusProcessamentoCompleto = 2; // sucesso
          
        }else{
         
          this.statusProcessamentoCompleto = 3; // erro 
          
        }


    }, errorResponse => {

      this.setSessionExpired(errorResponse);
      
    });

  }

  
 

  /*METODO PARA CRIAR O FORMULARIO E SEUS ITENS : VARIOS METODOS*/
  criarFormularioItemPorItem(){
    
    let formularioParaCopiar: number = this.data.idFormulario;
    let idFormularioCriado: number = 0;


  // 1) AJUSTAR TABELAS 
    this.cadastroFichaMonitoriaService.ajustarTabelas_DuplicacaoDeFormulario().subscribe( retorno => { //retorno booleano
          
        //ALTERAR STATUS DA TELA
        //0 aguardando / 1 processando / 2 sucesso / 3 erro
        if(retorno){
          this.ajustandoTabelas = 2;
          this.criandoFormulario = 1;
        }else{
          this.ajustandoTabelas = 3;
        }
        

        if(retorno){

    // 2) CRIAR FORMULARIO
          this.cadastroFichaMonitoriaService.criarFormulario_DuplicacaoDeFormulario(formularioParaCopiar).subscribe( retorno => { //retorno Number id formulario novo

              idFormularioCriado = Number(retorno);
            
              if(idFormularioCriado > 0){
                this.criandoFormulario = 2;
                this.criandoMotivos = 1;
              }else{
                this.criandoFormulario = 3;
              }

              if(retorno > 0){

          //  3)  CRIAR MOTIVOS DE PARAMETROS (MOTIVOS DE CABEÇALHOS)
                this.cadastroFichaMonitoriaService.criarMotivoParametro_DuplicacaoDeFormulario(formularioParaCopiar, idFormularioCriado).subscribe( retorno => { //retorno booleano

                  if(retorno){
                    this.criandoMotivos = 2;
                    this.criandoParametros = 1;
                  }else{
                    this.criandoMotivos = 3;
                  }

                                 
                  if(retorno){

              //  4) CRIAR PARAMETROS (CABEÇALHOS)
                  this.cadastroFichaMonitoriaService.criarParametro_DuplicacaoDeFormulario(formularioParaCopiar, idFormularioCriado).subscribe( retorno => { //retorno booleano

                    if(retorno){
                      this.criandoParametros = 2;
                      this.criandoVinculosDeParametrosMotivos = 1;
                    }else{
                      this.criandoParametros = 3;
                    }

                    if(retorno){
                      
                //  5) CRIAR VINCULO MOTIVO X PARAMETRO (MOTIVO x CABEÇALHOS)
                      this.cadastroFichaMonitoriaService.criarVinculoMotivoParametro_DuplicacaoDeFormulario(formularioParaCopiar, idFormularioCriado).subscribe( retorno => { //retorno booleano
                 
                      if(retorno){
                        this.criandoVinculosDeParametrosMotivos = 2;
                      this.criandoGruposCategroria = 1;
                      }else{
                        this.criandoVinculosDeParametrosMotivos = 3;
                      }
                
                      if(retorno){

                  //  6) CRIAR GRUPOS DE CATEGORIAS
                        this.cadastroFichaMonitoriaService.criarGrupoCategoria_DuplicacaoDeFormulario(formularioParaCopiar, idFormularioCriado).subscribe( retorno => { //retorno booleano
                        
                        if(retorno){
                          this.criandoGruposCategroria = 2;
                        this.criandoCategorias = 1;
                        }else{
                          this.criandoGruposCategroria = 3;
                        }


                        if(retorno){

                    //  7) CRIAR CATEGORIAS
                        this.cadastroFichaMonitoriaService.criarCategoria_DuplicacaoDeFormulario(idFormularioCriado).subscribe( retorno => { //retorno booleano
                         
                          if(retorno){
                            this.criandoCategorias = 2;
                            this.criandoPerguntas = 1;
                          }else{
                            this.criandoCategorias = 3;
                          }                          
                          

                          if(retorno){

                      //  8) CRIAR PERGUNTAS
                            this.cadastroFichaMonitoriaService.criarPergunta_DuplicacaoDeFormulario(idFormularioCriado).subscribe( retorno => { //retorno booleano
                          
                            if(retorno){
                              this.criandoPerguntas = 2;
                              this.criandoRespostas = 1;
                            }else{
                              this.criandoPerguntas = 3;
                            }
                            
                            if(retorno){

                        //  9) CRIAR RESPOSTAS
                              this.cadastroFichaMonitoriaService.criarResposta_DuplicacaoDeFormulario(formularioParaCopiar, idFormularioCriado).subscribe( retorno => { //retorno booleano
                          
                              if(retorno){
                                this.criandoRespostas = 2;
                                this.criandoVinculosEntrePerguntasRespostas = 1;
                              }else{
                                this.criandoRespostas = 3;
                              }



                                    //  10) CRIAR VINCULO ENTRE MOTIVOS PERGUNTAS X RESPOSTAS
                                    this.cadastroFichaMonitoriaService.criarVinculoPerguntaResposta_DuplicacaoDeFormulario(formularioParaCopiar, idFormularioCriado).subscribe( retorno => { //retorno booleano
                        

                                        if(retorno){
                                          this.criandoVinculosEntrePerguntasRespostas = 2;
                                          this.msgSucesso = true;
                                        }else{
                                          this.msgErro = true;
                                        }



                                    }, errorResponse => {

                                      this.setSessionExpired(errorResponse);
                                    });    
      
                                    



                            
                              }, errorResponse => {

                                this.setSessionExpired(errorResponse);
                              });    

                            }

                            }, errorResponse => {

                              this.setSessionExpired(errorResponse);
                            });   
                            
                          }

                          }, errorResponse => {

                            this.setSessionExpired(errorResponse);
                          });     
                          
                        }
                      
                        }, errorResponse => {

                          this.setSessionExpired(errorResponse);
                        });    
                        
                      }
                    
                    }, errorResponse => {

                      this.setSessionExpired(errorResponse);
                    });

                  }

                }, errorResponse => {

                  this.setSessionExpired(errorResponse);
                });

              }

            }, errorResponse => {

              this.setSessionExpired(errorResponse);
            });

          }

        }, errorResponse => {

          this.setSessionExpired(errorResponse);
        });
     
      }

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    });






  }

  public sair(): void {

    this.dialogRef.close();
  }


  public setSessionExpired(errorResponse:any) : boolean {

    if(errorResponse.status == 401){

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }


  public resetSessionExpired(){

    if(this.sessionExpired){

			this.sair();
			this.toastr.warning("Sua sessão expirou, faça o login novamente!");
		}
  }

  
  
}

